export default {
  primary1: "#30475e",
  primary2: "#f05454",
  primary3: "#070d59",
  secondary1: "#5c6e91",
  secondary2: "#9f5f80",
  tertiary1: "#fd3a69",
  light1: "#f1f6f9",
  light2: "#f6f5f5",
  light3: "#c3d9e9",
  dark1: "#2c061f",
  white: "#fff",
  black: "#000",
};
